module.exports = __webpack_public_path__ + "img/P150T_weapon_136.93493e1e.png";